import { tokens } from "@core/theme/tokens";
import { securityLogFilterBarStyles } from "./securityLogStyles";

// Contenedor + fila de chips + botón "filtros adicionales", idéntico entre
// la Bitácora de accesos y la Traza HTTP (Seguridad) salvo el rótulo del
// grupo, las opciones de chip y el texto/aria-label del botón final —
// jscpd lo marcó como clon exacto entre `AccessLogScreen.tsx` y
// `HttpRequestLogScreen.tsx` (quality-gate, revisión de duplicación
// 2026-09-23).
export function SecurityLogFilterBar<TValue extends string | boolean>({
  ariaLabel,
  groupLabel,
  chips,
  activeValue,
  onChipChange,
  trailingText,
  trailingAriaLabel,
  onOpenAdvanced,
}: {
  ariaLabel: string;
  groupLabel: string;
  chips: ReadonlyArray<readonly [TValue, string]>;
  activeValue: TValue;
  onChipChange: (value: TValue) => void;
  trailingText: string;
  trailingAriaLabel: string;
  onOpenAdvanced: () => void;
}) {
  return (
    <section
      aria-label={ariaLabel}
      style={{
        display: "flex",
        alignItems: "center",
        gap: securityLogFilterBarStyles.filterBar.gap,
        padding: securityLogFilterBarStyles.filterBar.padding,
        marginBottom: securityLogFilterBarStyles.filterBar.marginBottom,
        border: `1px solid ${tokens.surface.line}`,
        borderRadius: tokens.radius.lg,
        background: tokens.surface.bg2,
      }}
    >
      <span className="label">{groupLabel}</span>
      <div style={{ display: "flex", gap: 8 }}>
        {chips.map(([value, label]) => (
          <button
            key={String(value)}
            type="button"
            className={`chip${activeValue === value ? " on" : ""}`}
            aria-pressed={activeValue === value}
            onClick={() => onChipChange(value)}
          >
            {label}
          </button>
        ))}
      </div>
      <button
        type="button"
        aria-label={trailingAriaLabel}
        onClick={onOpenAdvanced}
        style={{
          marginLeft: "auto",
          color: tokens.text.disabled,
          font: `400 11.5px ${tokens.font.ui}`,
          background: "transparent",
          border: 0,
          padding: 0,
          cursor: "pointer",
        }}
      >
        {trailingText}
      </button>
    </section>
  );
}
